import React, { useState, useEffect } from "react";
import { Avatar, CardHeader, Typography } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	cardHeader: {
		cursor: "pointer",
		"& .MuiCardHeader-title": {
			fontFamily: '"Inter", "Poppins", sans-serif',
			fontWeight: 600,
			fontSize: "0.9rem",
			color: theme.palette.type === "dark" ? "#F1F5F9" : "#1E293B",
		},
		"& .MuiCardHeader-subheader": {
			fontFamily: '"Inter", "Poppins", sans-serif',
			fontWeight: 400,
			fontSize: "0.78rem",
			color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
		},
	},
	avatar: {
		width: 42,
		height: 42,
		borderRadius: "50%",
		border: theme.palette.type === "dark"
			? "2px solid rgba(255,255,255,0.1)"
			: "2px solid #F1F5F9",
	},
}));

const TicketInfo = ({ contact, ticket, onClick }) => {
	const classes = useStyles();
	
	const { user } = ticket
	const [userName, setUserName] = useState('')
	const [contactName, setContactName] = useState('')

	useEffect(() => {
		if (contact) {
			setContactName(contact.name);
			if (document.body.offsetWidth < 600) {
				if (contact.name.length > 10) {
					const truncadName = contact.name.substring(0, 10) + '...';
					setContactName(truncadName);
				}
			}
		}

		if (user && contact) {
			setUserName(`${i18n.t("messagesList.header.assignedTo")} ${user.name}`);

			if (document.body.offsetWidth < 600) {
				setUserName(`${user.name}`);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<CardHeader
			onClick={onClick}
			className={classes.cardHeader}
			titleTypographyProps={{ noWrap: true }}
			subheaderTypographyProps={{ noWrap: true }}
			avatar={
				<Avatar
					src={`${ticket?.contact?.urlPicture}`}					
					alt="contact_image"
					className={classes.avatar}
				/>}
			title={`${contactName} #${ticket.id}`}
			subheader={ticket.user && `${userName}`}
		/>
	);
};

export default TicketInfo;
